// Auto-generated file created by SVGR source illustrationTemplate.ts
// DO NOT EDIT THIE FILE
import { SVGUniqueID } from './svg-unique-id';
import type { IllustrationProps } from './types';
const Illustration = (props: IllustrationProps) => (
  <svg
    width={141}
    height={101}
    viewBox="0 0 141 101"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_113_80459)">
      <path
        d="M101 42.9062H24.5V38.4062C24.5 37.2128 24.9741 36.0682 25.818 35.2242C26.6619 34.3803 27.8065 33.9063 29 33.9063H96.5C97.6935 33.9063 98.8381 34.3803 99.682 35.2242C100.526 36.0682 101 37.2128 101 38.4062V42.9062Z"
        fill="#FF9DBE"
      />
      <path
        d="M101.299 42.9062H24.7988V38.4062C24.7988 37.2128 25.2729 36.0682 26.1168 35.2242C26.9607 34.3803 28.1054 33.9063 29.2988 33.9063H96.7988C97.9923 33.9063 99.1369 34.3803 99.9808 35.2242C100.825 36.0682 101.299 37.2128 101.299 38.4062V42.9062Z"
        stroke="#29292F"
        strokeLinejoin="round"
      />
      <path
        d="M96.7988 94.668H29.2988C28.1054 94.668 26.9607 94.1939 26.1168 93.35C25.2729 92.5061 24.7988 91.3614 24.7988 90.168V42.918H101.299V90.168C101.299 91.3614 100.825 92.5061 99.9808 93.35C99.1369 94.1939 97.9923 94.668 96.7988 94.668Z"
        fill="#FFD5E1"
        stroke="#29292F"
        strokeLinejoin="round"
      />
      <path
        d="M57.8398 52.416H35.3398C34.0972 52.416 33.0898 53.4234 33.0898 54.666V83.916C33.0898 85.1587 34.0972 86.166 35.3398 86.166H57.8398C59.0825 86.166 60.0898 85.1587 60.0898 83.916V54.666C60.0898 53.4234 59.0825 52.416 57.8398 52.416Z"
        fill="#FFD5E1"
        stroke="#29292F"
        strokeLinejoin="round"
      />
      <path
        d="M89.3399 65.918H69.0898C67.8472 65.918 66.8398 66.9253 66.8398 68.168V83.918C66.8398 85.1606 67.8472 86.168 69.0898 86.168H89.3399C90.5825 86.168 91.5899 85.1606 91.5899 83.918V68.168C91.5899 66.9253 90.5825 65.918 89.3399 65.918Z"
        fill="#FFD5E1"
        stroke="#29292F"
        strokeLinejoin="round"
      />
      <path
        d="M67.0479 52.8711H92.0479"
        stroke="#29292F"
      />
      <path
        d="M67.0479 60.5625H92.0479"
        stroke="#29292F"
      />
      <path
        d="M67.0479 56.7207H92.0479"
        stroke="#29292F"
      />
      <path
        d="M12.5 19.2449L12.9342 19.2601C14.6754 19.324 16.3201 20.0769 17.5063 21.3531C18.6926 22.6294 19.3235 24.3245 19.2601 26.0658L19.2428 26.5L19.2601 26.0658C19.2915 25.2035 19.4924 24.3559 19.8514 23.5713C20.2104 22.7866 20.7205 22.0805 21.3525 21.493C21.9845 20.9056 22.726 20.4484 23.5348 20.1476C24.3435 19.8468 25.2036 19.7082 26.0658 19.7399L26.5 19.7572L26.0658 19.7399C25.2035 19.7085 24.3559 19.5076 23.5713 19.1486C22.7867 18.7896 22.0805 18.2795 21.493 17.6475C20.9056 17.0155 20.4484 16.274 20.1476 15.4652C19.8468 14.6565 19.7082 13.7964 19.7399 12.9342L19.7551 12.5L19.7399 12.9342C19.7085 13.7965 19.5076 14.6441 19.1486 15.4287C18.7896 16.2133 18.2795 16.9195 17.6475 17.507C17.0155 18.0944 16.274 18.5516 15.4652 18.8524C14.6565 19.1532 13.7964 19.2918 12.9342 19.2601L12.5 19.2449Z"
        fill="white"
        stroke="#29292F"
        strokeMiterlimit={10}
        strokeLinejoin="round"
      />
      <path
        d="M34.5 21.3178L34.8101 21.3287C36.0539 21.3743 37.2286 21.912 38.076 22.8237C38.9233 23.7353 39.3739 24.9461 39.3287 26.1899L39.3163 26.5L39.3287 26.1899C39.3511 25.574 39.4946 24.9685 39.751 24.408C40.0075 23.8476 40.3718 23.3432 40.8232 22.9236C41.2746 22.504 41.8043 22.1774 42.382 21.9626C42.9596 21.7477 43.574 21.6487 44.1899 21.6713L44.5 21.6837L44.1899 21.6713C43.574 21.6489 42.9685 21.5054 42.4081 21.249C41.8476 20.9925 41.3432 20.6282 40.9236 20.1768C40.504 19.7254 40.1774 19.1957 39.9626 18.618C39.7477 18.0404 39.6487 17.426 39.6714 16.8101L39.6822 16.5L39.6714 16.8101C39.649 17.426 39.5054 18.0315 39.249 18.592C38.9925 19.1524 38.6282 19.6568 38.1768 20.0764C37.7254 20.496 37.1957 20.8226 36.618 21.0375C36.0404 21.2523 35.426 21.3513 34.8101 21.3287L34.5 21.3178Z"
        fill="white"
        stroke="#29292F"
        strokeWidth={0.9}
        strokeMiterlimit={10}
        strokeLinejoin="round"
      />
      <path
        d="M9.5 39.8725L9.71709 39.8801C10.5877 39.912 11.41 40.2884 12.0032 40.9266C12.5963 41.5647 12.9117 42.4123 12.8801 43.2829L12.8714 43.5L12.8801 43.2829C12.8957 42.8518 12.9962 42.4279 13.1757 42.0356C13.3552 41.6433 13.6103 41.2902 13.9263 40.9965C14.2423 40.7028 14.613 40.4742 15.0174 40.3238C15.4217 40.1734 15.8518 40.1041 16.2829 40.1199L16.5 40.1286L16.2829 40.1199C15.8518 40.1043 15.4279 40.0038 15.0356 39.8243C14.6433 39.6448 14.2902 39.3897 13.9965 39.0737C13.7028 38.7577 13.4742 38.387 13.3238 37.9826C13.1734 37.5783 13.1041 37.1482 13.1199 36.7171L13.1275 36.5L13.1199 36.7171C13.1043 37.1482 13.0038 37.5721 12.8243 37.9644C12.6448 38.3567 12.3897 38.7098 12.0737 39.0035C11.7577 39.2972 11.387 39.5258 10.9826 39.6762C10.5783 39.8266 10.1482 39.8959 9.71709 39.8801L9.5 39.8725Z"
        fill="white"
        stroke="#29292F"
        strokeWidth={0.9}
        strokeMiterlimit={10}
        strokeLinejoin="round"
      />
      <path
        d="M126 25.5H49.5V21C49.5 19.8065 49.9741 18.6619 50.818 17.818C51.6619 16.9741 52.8065 16.5 54 16.5H121.5C122.693 16.5 123.838 16.9741 124.682 17.818C125.526 18.6619 126 19.8065 126 21V25.5Z"
        fill="#FF9DBE"
        stroke="#29292F"
        strokeLinejoin="round"
      />
      <path
        d="M121.5 77.2519H54C52.8065 77.2519 51.6619 76.7779 50.818 75.9339C49.9741 75.09 49.5 73.9454 49.5 72.7519V25.502H126V72.7519C126 73.9454 125.526 75.09 124.682 75.9339C123.838 76.7779 122.693 77.2519 121.5 77.2519Z"
        fill="#F9F9F9"
        stroke="#29292F"
        strokeLinejoin="round"
      />
      <path
        d="M112.498 23.25C113.741 23.25 114.748 22.2426 114.748 21C114.748 19.7574 113.741 18.75 112.498 18.75C111.255 18.75 110.248 19.7574 110.248 21C110.248 22.2426 111.255 23.25 112.498 23.25Z"
        fill="#29292F"
      />
      <path
        d="M119.249 23.25C120.492 23.25 121.499 22.2426 121.499 21C121.499 19.7574 120.492 18.75 119.249 18.75C118.006 18.75 116.999 19.7574 116.999 21C116.999 22.2426 118.006 23.25 119.249 23.25Z"
        fill="#29292F"
      />
      <path
        d="M83.248 34.502H60.748C59.5054 34.502 58.498 35.5093 58.498 36.752V66.002C58.498 67.2446 59.5054 68.252 60.748 68.252H83.248C84.4907 68.252 85.498 67.2446 85.498 66.002V36.752C85.498 35.5093 84.4907 34.502 83.248 34.502Z"
        fill="#F9F9F9"
        stroke="#29292F"
        strokeLinejoin="round"
      />
      <path
        d="M114.748 48.0029H94.498C93.2554 48.0029 92.248 49.0103 92.248 50.2529V66.0029C92.248 67.2456 93.2554 68.2529 94.498 68.2529H114.748C115.991 68.2529 116.998 67.2456 116.998 66.0029V50.2529C116.998 49.0103 115.991 48.0029 114.748 48.0029Z"
        fill="#F9F9F9"
        stroke="#29292F"
        strokeLinejoin="round"
      />
      <path
        d="M92.4561 34.958H117.456"
        stroke="#29292F"
      />
      <path
        d="M92.4561 42.6484H117.456"
        stroke="#29292F"
      />
      <path
        d="M92.4561 38.8066H117.456"
        stroke="#29292F"
      />
      <mask
        id="path-21-inside-1_113_80459"
        fill="white"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M89.1445 52.8156V49L95.5038 52.8156H129.895C132.104 52.8156 133.895 54.6064 133.895 56.8156V86.9998C133.895 89.209 132.104 90.9998 129.895 90.9998H85.5276C83.3185 90.9998 81.5276 89.209 81.5276 86.9998V56.8155C81.5276 54.6064 83.3184 52.8156 85.5276 52.8156H89.1445Z"
        />
      </mask>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M89.1445 52.8156V49L95.5038 52.8156H129.895C132.104 52.8156 133.895 54.6064 133.895 56.8156V86.9998C133.895 89.209 132.104 90.9998 129.895 90.9998H85.5276C83.3185 90.9998 81.5276 89.209 81.5276 86.9998V56.8155C81.5276 54.6064 83.3184 52.8156 85.5276 52.8156H89.1445Z"
        fill="#37363F"
      />
      <path
        d="M89.1445 49L89.659 48.1425L88.1445 47.2338V49H89.1445ZM89.1445 52.8156V53.8156H90.1445V52.8156H89.1445ZM95.5038 52.8156L94.9893 53.673L95.2268 53.8156H95.5038V52.8156ZM88.1445 49V52.8156H90.1445V49H88.1445ZM96.0183 51.9581L89.659 48.1425L88.63 49.8575L94.9893 53.673L96.0183 51.9581ZM95.5038 53.8156H129.895V51.8156H95.5038V53.8156ZM129.895 53.8156C131.551 53.8156 132.895 55.1587 132.895 56.8156H134.895C134.895 54.0541 132.656 51.8156 129.895 51.8156V53.8156ZM132.895 56.8156V86.9998H134.895V56.8156H132.895ZM132.895 86.9998C132.895 88.6567 131.551 89.9998 129.895 89.9998V91.9998C132.656 91.9998 134.895 89.7613 134.895 86.9998H132.895ZM129.895 89.9998H85.5276V91.9998H129.895V89.9998ZM85.5276 89.9998C83.8707 89.9998 82.5276 88.6567 82.5276 86.9998H80.5276C80.5276 89.7612 82.7662 91.9998 85.5276 91.9998V89.9998ZM82.5276 86.9998V56.8155H80.5276V86.9998H82.5276ZM82.5276 56.8155C82.5276 55.1587 83.8707 53.8156 85.5276 53.8156V51.8156C82.7662 51.8156 80.5276 54.0541 80.5276 56.8155H82.5276ZM85.5276 53.8156H89.1445V51.8156H85.5276V53.8156Z"
        fill="#29292F"
        mask="url(#path-21-inside-1_113_80459)"
      />
      <rect
        x={92.9373}
        y={79.9504}
        width={16.4557}
        height={6.63685}
        rx={1.5}
        fill="#FCFBF7"
        stroke="#29292F"
      />
      <rect
        x={112.575}
        y={79.9504}
        width={16.4557}
        height={6.63685}
        rx={1.5}
        fill="#FFD5E1"
        stroke="#29292F"
      />
      <path
        d="M85.8916 60.4525H127.349"
        stroke="#FCFBF7"
      />
      <path
        d="M85.8916 69.6316H100.074"
        stroke="#FCFBF7"
      />
      <path
        d="M85.8916 65.2678H118.621"
        stroke="#FCFBF7"
      />
    </g>
    <defs>
      <clipPath id="clip0_113_80459">
        <rect
          width={140}
          height={100}
          fill="white"
          transform="translate(0.5 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);
const SvgTourFromExistingDemo = (props: IllustrationProps) => (
  <SVGUniqueID>{Illustration(props)}</SVGUniqueID>
);
export default SvgTourFromExistingDemo;
